import Vue from 'vue';
import Popper from 'vue-popperjs';
export default Vue.extend({
    components: { Popper },
    props: {
        content: { type: String, default: '' },
        substituteText: { type: String, default: '' },
        constrainWidth: { type: Boolean, default: true },
        width: { default: null, type: Number },
        link: { type: String, default: null },
    },
    methods: {
        openLink() {
            if (this.link) {
                window.open(this.link);
            }
        }
    }
});
